var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/arrow-right-small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.3830622,7.13106538 L12.4419417,7.18305826 L16.8169417,11.5580583 C16.8406982,11.582429 16.8568852,11.6011971 16.8719288,11.6208856 L16.8169417,11.5580583 C16.8448528,11.5859693 16.8695721,11.6158634 16.8910997,11.6472871 C16.9012958,11.6622632 16.9109751,11.6778053 16.9199721,11.6937828 C16.9276237,11.7072978 16.9345776,11.7208208 16.9410061,11.734529 C16.9788248,11.8150367 17,11.9050455 17,12 C17,12.0334768 16.997368,12.0663388 16.9922997,12.0983905 C16.9894289,12.1162027 16.9858244,12.1339534 16.9814446,12.1515506 C16.9778324,12.1662492 16.9737237,12.1805017 16.9691315,12.1945354 C16.9647456,12.2078759 16.959821,12.2213839 16.9544158,12.2347429 C16.9471717,12.2525792 16.9393307,12.2696056 16.9307684,12.2861991 C16.9261069,12.2953431 16.920961,12.304743 16.9155556,12.3140335 C16.9037845,12.3341115 16.8912778,12.353084 16.8778049,12.3712985 C16.8752799,12.3747952 16.8721366,12.3789441 16.8689346,12.3830622 L16.8568957,12.3980237 C16.8465266,12.4105636 16.8356774,12.422692 16.8243763,12.4343807 L16.8169417,12.4419417 L12.4419417,16.8169417 C12.1978641,17.0610194 11.8021359,17.0610194 11.5580583,16.8169417 C11.3327558,16.5916393 11.3154248,16.2371199 11.5060654,15.9919378 L11.5580583,15.9330583 L14.865,12.625 L7.625,12.625 C7.27982203,12.625 7,12.345178 7,12 C7,11.6794776 7.24127512,11.415308 7.5521118,11.3792048 L7.625,11.375 L14.865,11.375 L11.5580583,8.06694174 C11.3327558,7.84163926 11.3154248,7.48711985 11.5060654,7.24193785 L11.5580583,7.18305826 C11.7833607,6.95775579 12.1378801,6.94042483 12.3830622,7.13106538 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/arrow-right-small",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightSmall);
export default __webpack_public_path__ + "static/media/arrow-right-small.18cb2275eaf81a685f413dff649689bc.svg";
export { ForwardRef as ReactComponent };